import * as React from 'react';
import styled from 'styled-components';
import Button from 'material-ui/Button';
import { colors } from 'kaizen-ui-colors/lib';
import { EmptyStateImage } from './EmptyStateImage';

interface IProps {
  title: string;
  message: string;
  actionLabel?: string;
  action: () => void;
  showEmptyStateImage?: boolean;
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  margin-top: 5vh;

  p {
    font-size: 1.230769231rem;
    margin-bottom: 36px;
  }

  svg {
    color: ${colors.ash_light__c3cbdd};
    margin-bottom: 12px;
  }
`;

export class ErrorScreen extends React.PureComponent<IProps, {}> {
  private html() {
    return { __html: this.props.message };
  }

  public render() {
    const { title, actionLabel, action, showEmptyStateImage } = this.props;
    return (
      <Wrapper>
        {showEmptyStateImage ? <EmptyStateImage /> : null}
        <h1 dangerouslySetInnerHTML={{ __html: title }} />
        <p dangerouslySetInnerHTML={this.html()} />
        {actionLabel ? (
          <Button color="primary" variant="raised" onClick={action}>
            {actionLabel}
          </Button>
        ) : null}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/ErrorScreen.tsx